import type { GridLayout } from '@/components/report-canvas/types';

// ── AR analytics surfaces ─────────────────────────────────────────────────────
// Surface ids key the persisted layouts (org default + per-user override).
// Never rename one casually — persisted rows reference it.

export const AR_SUMMARY_ANALYTICS_SURFACE = 'ar-summary-analytics';
export const AR_CUSTOMER_PROFILE_ANALYTICS_SURFACE =
  'ar-customer-profile-analytics';

/**
 * Developer-default layouts: a single aging-overview chart, matching what the
 * pages rendered before the canvas existed. Fixed ids keep the default stable
 * across sessions (these never collide with runtime ids, which are random).
 */
export const AR_SUMMARY_DEFAULT_LAYOUT: GridLayout = [
  {
    id: 'default-aging-chart',
    x: 0,
    y: 0,
    w: 12,
    h: 8,
    component: { type: 'ar-aging-chart', id: 'default-aging-chart' },
  },
];

export const AR_CUSTOMER_PROFILE_DEFAULT_LAYOUT: GridLayout =
  AR_SUMMARY_DEFAULT_LAYOUT;
